module.exports = __webpack_public_path__ + "static/media/bicikl_ikona_v2.ab6d50fa.png";